// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__CM7Jf","info":"Timeline_info__AFdno","card":"Timeline_card__df+Hu","content":"Timeline_content__DBgbl"};